import factories from '../generics/factories'
const { factory, createMixin, fetchMixin, patchMixin, deleteMixin } = factories

const store = factory(
  {
    entityName: 'Image',
    urlTemplate: id => id ? `api/converter_images/${id}/` : `api/converter_images/`
  },
  createMixin,
  fetchMixin,
  patchMixin,
  deleteMixin
)

export default store
